import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, Status, TriggeredEvent, Wrapper5 } from '../../../service/local.service';

@Component({
  selector: 'app-global-config-edit',
  templateUrl: './global-config-edit.component.html',
  styleUrls: ['./global-config-edit.component.scss']
})
export class GlobalConfigEditComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["general_config"];
  wrapper: Wrapper5; maxBodyHeight = 0;
  id: string;
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: { v2: null, v1: '', v3: '', v4: '0' } as KeyValues5
      } as Wrapper5;
    }
    else {
      this.configurationManagementService.getGlobalConfiguration(this.id).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.configurationManagementService.saveGlobalConfiguration(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        this.wrapper.content.key = this.id == '' ? result.id : this.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }
    });
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
